import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DestroyBase } from 'src/app/components/common/ng-destroy-base';
import { CalculationModelOverview } from '../../../models/calculation-model-overview';
import { CalculationModelService } from '../../../services/calculation-model-service';
import { DataBindingDirective, SelectableSettings, SelectionEvent } from '@progress/kendo-angular-grid';
import { AppLoadingIndicatorService } from '../../../../../services/app-loading-indicator.service';
import { process } from '@progress/kendo-data-query';
import { StringHelper } from '../../../../../components/common/string-helper/string-helper';

/**
 * Calculation model view component: Shows import templates*/
@Component({
  selector: 'calculation-model-view',
  templateUrl: './calculation-model-view.component.html',
  styleUrls: ['./calculation-model-view.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalculationModelViewComponent extends DestroyBase implements OnInit {
  /**
   *DataBindingDirective
   */
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

  /**
   * The list of models
   */
  models: CalculationModelOverview[] = [];

  /**
   * Grid view
   */
  public gridView: CalculationModelOverview[];

  /**
   * Search active?
   */
  searchActive = false;

  /**
   * Selectable settings
   */
  public selectableSettings: SelectableSettings = {
    checkboxOnly: false,
    mode: 'single',
    drag: false,
  };

  /**
   * Selected IDs
   */
  public selectedIds: number[] = [];

  /**
   * Constructor
   * @param cmService CalculationModelService
   * @param ref ChangeDetectorRef
   */
  constructor(private cmService: CalculationModelService, private ref: ChangeDetectorRef, private appLoadingIndicator: AppLoadingIndicatorService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.appLoadingIndicator.show();

    setTimeout(() => {
      this.cmService.triggerSelectedId(0);
    })

    this.subscriptions.add(this.cmService.getCalculationModels().subscribe(data => {
      this.gridView = data;
      this.models = data;
      this.appLoadingIndicator.hide();
      this.ref.markForCheck();
    }));

    this.subscriptions.add(this.cmService.searchActive$.subscribe(active => {
      this.searchActive = active;
      this.ref.markForCheck();
    }));
  }

  /**
   * Called on model selection
   * @param e Selection event
   */
  onSelect(e: SelectionEvent) {
    if (e.selectedRows.length > 0) {
      const item = e.selectedRows[0].dataItem;
      this.cmService.triggerSelectedId(item.id);
      this.cmService.triggerArchiveStatus(item.statusId);
    }
  }

  /**
   * Search
   * @param filters Search filters
   */
  search(filters: CalculationModelOverview) {
    const filter = [];
    if (!StringHelper.isNullOrEmpty(filters.name)) {
      filter.push({
        field: "name",
        operator: "contains",
        value: filters.name,
      })
    }
    if (!StringHelper.isNullOrEmpty(filters.country)) {
      filter.push({
        field: "country",
        operator: "contains",
        value: filters.country,
      })
    }
    if (!StringHelper.isNullOrEmpty(filters.sector)) {
      filter.push({
        field: "sector",
        operator: "contains",
        value: filters.sector,
      })
    }
    if (!StringHelper.isNullOrEmpty(filters.status)) {
      filter.push({
        field: "status",
        operator: "contains",
        value: filters.status,
      })
    }
    if (!StringHelper.isNullOrEmpty(filters.valuationMethod)) {
      filter.push({
        field: "valuationMethod",
        operator: "contains",
        value: filters.valuationMethod,
      })
    }
    this.gridView = process(this.models, {
      filter: {
        logic: "and",
        filters: filter,
      },
    }).data;

    this.dataBinding.skip = 0;
  }
}
